import {useCallback} from "react";

/**
 * Хук для обработки изменения значения поля в Inertia форме
 * @param {string} name - имя поля
 * @param {object} form - объект из useForm (Inertia)
 * @returns {Function} onChange handler
 */
export default function useInertiaField(name, form) {
    return useCallback((e) => {
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        form.setData(name, value);

        if (form.hasErrors) {
            form.clearErrors(name);
        }
    }, [name, form]);
}
